import store from '@/store';
import router from '@/router';

/**
 *  별도 안내페이지로 등록된 지점 목록
 *  저스트코: justco
 *
 *
 */

export const getList = () => {
  // 로컬 테스트용
  const LocalTest = {
    '609509970051c8001b450f40': 'justco', // 프론트원 ID임
  };
  // 상용망
  const PROD_LIST: { [key: string]: string } = {
    '6142f7918352ce001bd46220': 'justco',
  };

  //   개발망
  const DEV_LIST: { [key: string]: string } = {
    '6142ceebf83a1f001b034658': 'justco',
    ...(import.meta.env.VITE_ENV === 'local' ? LocalTest : ''),
  } as const;

  return import.meta.env.VITE_ENV === 'master' ? PROD_LIST : DEV_LIST;
};

/**
 * 주문 결제 완료 후, 지점에 맞는 안내페이지로 이동합니다.
 *
 */
export function usePushCompleteCenter() {
  return router.push('/outbound/complete');
}
